const MENUS = document.querySelectorAll(".menu-list--navigation");

const TOGGLE = (menu, item, e) => {
    e.stopPropagation();

    if (document.activeElement && !item.contains(document.activeElement)) {
        document.activeElement.blur();
    }

    item.querySelector(":scope > a, :scope > span").focus();

    const parent = item.closest(".menu-list--navigation");
    const span_child = item.querySelector(":scope > span");
    // first, remove all instances of `is-active` and `has-active`
    const elements = parent.querySelectorAll(".is-active, .has-active");
    let is_active = false;

    if (item.classList.contains("is-active")) {
        is_active = true;
    }

    elements.forEach((element) => {
        element.classList.remove("is-active", "has-active");
    });

    parent.classList.remove("has-active");

    // skip the current `li` and go over its head to add the other `is-actives` and `has-actives` back.
    let itemParent = item.parentElement;
    if (item.parentNode.closest("li") || !is_active) {
        while (itemParent) {
            if (itemParent.classList.contains("menu-list__item")) {
                itemParent.classList.add("is-active");
            } else if (itemParent.classList.contains("menu-list")) {
                itemParent.classList.add("has-active");
            }

            itemParent = itemParent.parentElement;
        }
    }

    if (!is_active) {
        // Prevent default navigation for top-level items to allow menu opening
        if (!item.parentNode.closest("li")) {
            e.preventDefault();
        }

        item.classList.add("is-active");

    } else if (span_child !== null) {
        span_child.blur();
    }
};

MENUS.forEach((menu) => {
    const TOP_ITEMS = menu.querySelectorAll(":scope > li");

    TOP_ITEMS.forEach((item) => {
        if (item.querySelector("ul")) {
            item.querySelector(":scope > a, :scope > span").addEventListener("click", (e) => {
                TOGGLE(menu, item, e);
            }, { passive: false });
        }
    });

    const BUTTONS = menu.querySelectorAll("li > button");

    BUTTONS.forEach((button) => {
        button.addEventListener("click", (e) => {
            TOGGLE(menu, button.parentElement, e);
        }, { passive: true });
    });
});

/**
 * Global "Click Outside" Handler
 * This handles both touch and click to clear all menus if
 * the target is not contained within one of our MENUS.
 */
["click"].forEach(eventType => {
    document.addEventListener(eventType, (e) => {
        const PATH = e.path || (e.composedPath && e.composedPath());

        // Check if the click/touch was inside ANY of the defined menus
        const IS_INSIDE_MENU = Array.from(MENUS).some(menu =>
            PATH.includes(menu)
        );

        if (!IS_INSIDE_MENU) {
            MENUS.forEach(menu => {
                // Remove active classes from items
                menu.querySelectorAll(".is-active").forEach(activeItem => {
                    activeItem.classList.remove("is-active");
                });

                // Remove active class from the parent container
                menu.closest(".menu-list--navigation").classList.remove("has-active");
            });
        }
    });
});
